import React, { useEffect, useState } from "react";
import DemoInterestedSectionCareers from "../../Component/DemoInterestedSectionCareers";
import LifestyleSection from "./component/LifestyleSection";
import CareersBannerSection from "./component/CareersBannerSection";
import CareersVideoSection from "./component/CareersVideoSection";

function CareersPage() {
  const [acfData, setAcfData] = useState(null);
  const onRefresh = async () => {
    try {
      const response = await fetch(
        "https://www.lagunacreek.io/blog/wp-json/custom/v1/acf-data/careers"
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const source = await response.json();
      const acf_fields = source?.acf_fields;
      setAcfData(acf_fields);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    onRefresh();
  }, []);

  return (
    <>
      <CareersBannerSection careers_banner={acfData?.careers_banner} />
      <CareersVideoSection learn_more_about_lc={acfData?.learn_more_about_lc} />
      <LifestyleSection laguna_creek_lifestyle={acfData?.laguna_creek_lifestyle} />
      <DemoInterestedSectionCareers data={acfData} />
    </>
  );
}

export default CareersPage;
